import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C8_P3_S1_Title: {
    id: `case08.page03.slide01.title`,
  },
  C8_P3_S1_A1_Title: {
    id: `case08.page03.slide01.accordion1.title`,
  },
  C8_P3_S1_A1_Description: {
    id: `case08.page03.slide01.accordion1.description`,
  },

  C8_P3_S1_A1_Content_SwitchButton1_Label: {
    id: `case08.page03.slide01.accordion1.content.switch_button1.label`,
  },
  C8_P3_S1_A1_Content_SwitchButton2_Label: {
    id: `case08.page03.slide01.accordion1.content.switch_button2.label`,
  },
  C8_P3_S1_A1_Content_SwitchButton3_Label: {
    id: `case08.page03.slide01.accordion1.content.switch_button3.label`,
  },
  C8_P3_S1_A1_Content_SwitchButton4_Label: {
    id: `case08.page03.slide01.accordion1.content.switch_button4.label`,
  },

  C8_P3_S1_A2_Title: {
    id: `case08.page03.slide01.accordion2.title`,
  },
  C8_P3_S1_A2_Description: {
    id: `case08.page03.slide01.accordion2.description`,
  },
  C8_P3_S1_A2_P1_Title: {
    id: `case08.page03.slide01.accordion2.p1.title`,
  },
  C8_P3_S1_A2_P1_Description: {
    id: `case08.page03.slide01.accordion2.p1.description`,
  },
  C8_P3_S1_A2_P2_Title: {
    id: `case08.page03.slide01.accordion2.p2.title`,
  },
  C8_P3_S1_A2_P2_Description: {
    id: `case08.page03.slide01.accordion2.p2.description`,
  },
  C8_P3_S1_A2_P3_Title: {
    id: `case08.page03.slide01.accordion2.p3.title`,
  },
  C8_P3_S1_A2_P3_Description: {
    id: `case08.page03.slide01.accordion2.p3.description`,
  },
  C8_P3_S1_A2_Content_SwitchButton1_Label: {
    id: `case08.page03.slide01.accordion2.content.switch_button1.label`,
  },
  C8_P3_S1_A2_Content_SwitchButton2_Label: {
    id: `case08.page03.slide01.accordion2.content.switch_button2.label`,
  },
  C8_P3_S1_A2_Content1_Heading: {
    id: `case08.page03.slide01.accordion2.content1.heading`,
  },
  C8_P3_S1_A2_Content1_Button1_Label: {
    id: `case08.page03.slide01.accordion2.content1.button1.label`,
  },
  C8_P3_S1_A2_Content1_Button2_Label: {
    id: `case08.page03.slide01.accordion2.content1.button2.label`,
  },
  C8_P3_S1_A2_Content1_Button3_Label: {
    id: `case08.page03.slide01.accordion2.content1.button3.label`,
  },
  C8_P3_S1_A2_Content2_Heading: {
    id: `case08.page03.slide01.accordion2.content2.heading`,
  },
  C8_P3_S1_A2_Content2_Button1_Label: {
    id: `case08.page03.slide01.accordion2.content2.button1.label`,
  },
  C8_P3_S1_A2_Content2_Button2_Label: {
    id: `case08.page03.slide01.accordion2.content2.button2.label`,
  },
  C8_P3_S1_A2_Content2_Button3_Label: {
    id: `case08.page03.slide01.accordion2.content2.button3.label`,
  },
});
